import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  AvatarThemeColor,
  KENDO_AVATAR,
  KENDO_CARD,
} from '@progress/kendo-angular-layout';

interface StatusAlertState {
  icon: string;
  color: string;
  borderColor: string;
  themeColor: AvatarThemeColor;
  title: string;
}

@Component({
  selector: 'ldm-status-alert',
  standalone: true,
  imports: [CommonModule, TranslateModule, KENDO_CARD, KENDO_AVATAR],
  templateUrl: './status-alert.component.html',
  styleUrls: ['./status-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusAlertComponent {
  public type = input.required<'success' | 'error' | 'warning' | 'info'>();
  public shouldTranslateTitle = input<boolean>(true);
  public shouldTranslateMessage = input<boolean>(false);
  public title = input<string>();
  public message = input.required<string>();

  public statusAlertState = computed<StatusAlertState>(() => {
    switch (this.type()) {
      case 'success':
        return {
          icon: 'fa-circle-check',
          color: 'text-green-600',
          borderColor: 'border-green-600',
          themeColor: 'success',
          title: this.title() ?? 'SUCCESS.title',
        };
      case 'error':
        return {
          icon: 'fa-exclamation-circle',
          color: 'text-red-500',
          borderColor: 'border-red-500',
          themeColor: 'error',
          title: this.title() ?? 'ERROR.title',
        };
      case 'warning':
        return {
          icon: 'fa-triangle-exclamation',
          color: 'text-yellow-400',
          borderColor: 'border-yellow-400',
          themeColor: 'warning',
          title: this.title() ?? 'WARNING.title',
        };
      case 'info':
      default:
        return {
          icon: 'fa-circle-info',
          color: 'text-blue-500',
          borderColor: 'border-blue-500',
          themeColor: 'info',
          title: this.title() ?? 'INFO.title',
        };
    }
  });
}
